import React, { useState, useEffect } from "react"
import { Input, Form, Space, DatePicker, Tooltip, message } from "antd"
import TableCustom from "src/components/Table/CustomTable"
import { InputSearchStyle } from "../HumanResource/styled"
import SvgIcon from "src/components/SvgIcon"
import FilterIn from "./components/FilterIn"
// import ModalEdit from "./Modal/EditModal"
import NetworkManager from "src/services/PackageNetwork"
import CustomModal from "src/components/Modal/CustomModal"
import ImportModal from "../Bussiness/Contact/modal/ImportModalNetwork"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import RejectModal from "./Modal/RejectModal"
import CB1 from "src/components/Modal/CB1"
import PackageService from "src/services/PackageService"
import TabsBar from "./components/TabsBar"
import STORAGE, { getStorage } from "src/lib/storage"
import { simType } from "src/constants/constants"
import ModalEditContract from "./Modal/EditModal"
import dayjs from "dayjs"

const serviceType = [
  { key: "2", value: "Roaming" },
  { key: "1", value: "Local" },
]

const NetWorkPackageRequest = () => {
  const [searchValue, setSearchValue] = useState("")
  const [isModalImport, setIsModalImport] = useState(false)
  const [form] = Form.useForm()
  const [selectedId, setSelectedId] = useState(null)
  const [modalType, setModalType] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [editingRecord, setEditingRecord] = useState(null)
  const [dataSource, setDataSource] = useState([])
  const [openRejectModal, setOpenRejectModal] = useState(false)
  const [tabChange, setTabChange] = useState("all")
  const [rejectReason, setRejectReason] = useState("")
  const [summary, setSummary] = useState({})
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState({
    // contractCode: "",
    // customer: null,
    // status: null,
    // dateRange: [],
  })
  // const [networkList, setNetworkList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const handleImportClick = () => {
    setIsModalImport(true)
  }
  useEffect(() => {
    setDataSource(dataSource)
  }, [])

  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status: "0",
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: "1",
    },
    reject: {
      type: "reject",
      name: "Từ chối",
      status: "2",
    },
  }
  useEffect(() => {
    setFilter(prev => ({
      ...prev,
      status: Tabs[tabChange]?.status ?? "",
    }))
  }, [tabChange])

  const columns = [
    {
      title: "Tên gói cước",
      dataIndex: "package",
      align: "center",
      render: pkgName => pkgName?.name,
    },
    // {
    //   title: "Quốc gia",
    //   dataIndex: ["country", "title"],
    //   render: name => name || "-",
    //   align: "center",
    // },
    // {
    //   title: "Nhà mạng",
    //   dataIndex: ["network", "name"],
    //   render: name => name || "-",
    //   align: "center",
    // },
    // {
    //   title: "Nhà cung cấp",
    //   dataIndex: ["supplier", "name"],
    //   render: name => name || "-",
    //   align: "center",
    // },
    // {
    //   title: "Local/Roaming",
    //   dataIndex: "service_type",
    //   render: key => {
    //     const found = serviceType.find(item => item.key === key)
    //     return found ? found.value : key
    //   },
    //   align: "center",
    // },
    // {
    //   title: "Loại hình SIM",
    //   dataIndex: "service_type",
    //   render: key => {
    //     const found = simType.find(item => item.key === key)
    //     return found ? found.value : key
    //   },
    //   align: "center",
    // },

    // {
    //   title: "Dung lượng DATA",
    //   dataIndex: "data_quantity",
    //   render: text => `${text} GB`,
    //   align: "center",
    // },
    // {
    //   title: "Giá cũ",
    //   dataIndex: "old_price",
    //   render: text => {
    //     return new Intl.NumberFormat().format(text)
    //   },
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Giá mới",
    //   dataIndex: "new_price",
    //   render: text => {
    //     return new Intl.NumberFormat().format(text)
    //   },
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    {
      title: "Giá cũ",
      children: [
        {
          title: "Giá nhập",
          dataIndex: "price_buy_old",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Giá bán",
          dataIndex: "price_sell_old",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Phí hòa mạng",
          dataIndex: "fee_connection_old",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Phí sim",
          dataIndex: "fee_sim_old",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Giá gói cước",
          dataIndex: "old_price",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "VAT",
          dataIndex: "fee_vat_old",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
      ],
    },
    {
      title: "Giá mới",
      children: [
        {
          title: "Giá nhập",
          dataIndex: "price_buy_new",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Giá bán",
          dataIndex: "price_sell_new",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Phí hòa mạng",
          dataIndex: "fee_connection_new",
          align: "right",
          render: text => new Intl.NumberFormat().format(text),
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
        },
        {
          title: "Phí sim",
          dataIndex: "fee_sim_new",
          align: "right",
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
          render: text => new Intl.NumberFormat().format(text),
        },
        {
          title: "Giá gói cước",
          dataIndex: "new_price",
          align: "right",
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
          render: text => new Intl.NumberFormat().format(text),
        },
        {
          title: "VAT",
          dataIndex: "fee_vat_new",
          align: "right",
          onHeaderCell: () => ({
            style: { textAlign: "center" },
          }),
          render: text => new Intl.NumberFormat().format(text),
        },
      ],
    },
    {
      title: "Mô tả",
      dataIndex: "note",
      align: "center",
    },
    {
      title: "Ngày tạo",
      dataIndex: "requested_at",
      render: requestedAt =>
        requestedAt ? dayjs(requestedAt).format("DD/MM/YYYY") : "",
      align: "center",
    },

    {
      title: "Người tạo",
      dataIndex: "requester",
      render: reqBy => reqBy?.fullname || "-",
      align: "center",
    },
    {
      title: "Ngày duyệt",
      dataIndex: "approved_at",
      render: approverAt =>
        approverAt ? dayjs(approverAt).format("DD/MM/YYYY") : "",
      align: "center",
    },
    {
      title: "Người duyệt",
      dataIndex: "approver",
      render: approverBy => approverBy?.fullname || "-",
      align: "center",
    },

    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: status => {
        switch (String(status)) {
          case "0":
            return (
              <span style={{ color: "orange", fontWeight: "bold" }}>
                Chờ duyệt
              </span>
            )
          case "1":
            return (
              <span style={{ color: "green", fontWeight: "bold" }}>
                Đã duyệt
              </span>
            )
          case "2":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Từ chối</span>
            )
          default:
            return <span style={{ color: "gray", fontWeight: "bold" }}></span>
        }
      },
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const onlyView = record.status === "1" || record.status === "2"

        return (
          <PopupAction>
            {/* {permissions.includes("package.net.detail") && onlyView ? (
              <div onClick={() => handleViewDetail(record)}>
                <IconBase name="eye" />
                <span>Xem chi tiết</span>
              </div>
            ) : (
              <React.Fragment />
            )} */}

            {/* {permissions.includes("package.net.detail") ? (
              <div onClick={() => handleViewDetail(record)}>
                <IconBase name="eye" />
                <span>Xem chi tiết</span>
              </div>
            ) : (
              <React.Fragment />
            )} */}

            {/* {permissions.includes("package.net.update") && !onlyView ? (
              <div onClick={() => handleEdit(record)}>
                <IconBase name="edit" />
                <span>Sửa</span>
              </div>
            ) : (
              <React.Fragment />
            )} */}

            {/* {permissions.includes("package.net.delete") && !onlyView ? (
              <div onClick={() => handleSingleDelete(record)}>
                <IconBase name="delete" />
                <span>Xóa</span>
              </div>
            ) : (
              <React.Fragment />
            )} */}

            {permissions.includes("package.new.approve") && !onlyView ? (
              <div onClick={() => handleBrowse(record)}>
                <IconBase name="approval" />
                <span>Duyệt</span>
              </div>
            ) : (
              <React.Fragment />
            )}

            {permissions.includes("package.new.reject") && !onlyView ? (
              <div onClick={() => handleReject(record)}>
                <IconBase name="cancelApproval" />
                <span>Từ chối</span>
              </div>
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]
  const fetchNetworkData = async (keyword = "") => {
    setLoading(true)
    try {
      const response = await NetworkManager.listPackageRequest({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter: {
          // type: 1,
          ...filter,
        },
        keyword: keyword,
      })
      if (response && response?.success) {
        const users = response?.success?.data || []
        const total = response?.success?.total || users.length
        const current = response.current_page
        const perPage = response.per_page
        const networkData = response.success.data || []
        setDataSource(networkData)
        setPagination({
          ...pagination,
          total,
        })
        setSummary({
          totalAccounts: total,
        })
      }
    } catch (error) {
      console.error("Lỗi khi gọi API danh sách nhà mạng:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNetworkData(searchValue)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchNetworkData(searchValue)
      }
    }
  }, [filter, searchValue, refresh])
  const handleBrowse = async record => {
    try {
      const response = await NetworkManager.approvePackageRequest(record.ID)
      if (response?.message?.includes("thành công")) {
        message.success("Duyệt gói cước thành công")
        fetchNetworkData(searchValue)
      } else {
        message.error("Duyệt gói cước thất bại")
      }
    } catch (error) {
      console.error("Lỗi khi duyệt gói cước:", error)
      message.error("Đã xảy ra lỗi khi duyệt gói cước.")
    }
  }

  const handleReject = record => {
    setSelectedRecord(record.ID)
    // handleRefuse()
  }
  useEffect(() => {
    if (selectedRecord !== null) {
      handleRefuse()
    }
  }, [selectedRecord])
  const handleRefuse = async () => {
    try {
      const response = await NetworkManager.rejectPackageRequest(
        selectedRecord,
        // {
        //   note: rejectReason,
        // },
      )
      if (response?.message?.includes("thành công")) {
        message.success("Từ chối gói cước thành công")
        fetchNetworkData(searchValue)
      } else {
        message.error("Từ chối gói cước thất bại")
      }
    } catch (error) {
      console.error("Lỗi khi hủy duyệt gói cước:", error)
      message.error("Đã xảy ra lỗi khi hủy duyệt gói cước.")
    } finally {
      setOpenRejectModal(false)
    }
  }

  const handleDelete = async (ids = []) => {
    try {
      const res = await NetworkManager.packageDelete({ ids })
      if (res?.message?.toLowerCase().includes("thành công")) {
        message.success("Xóa gói cước thành công!")
        setDataSource(prev => prev.filter(item => !ids.includes(item.id)))
        // setDataSelected([])
        fetchNetworkData(searchValue)
      } else {
        message.error("Xóa gói cước không thành công!")
      }
    } catch (error) {
      console.error("Lỗi khi xóa gói cước:", error)
      message.error("Đã xảy ra lỗi khi xóa gói cước!")
    }
  }

  const handleSingleDelete = record => {
    CB1({
      title: `Bạn có chắc chắn muốn xóa gói cước <strong>${record?.name}</strong>?`,
      iconName: "delete-outline",
      okText: "Xóa",
      onOk: async close => {
        await handleDelete([record.ID])
        close()
      },
    })
  }
  const handleSearch = value => {
    setSearchValue(value)
    fetchNetworkData(value)
  }

  const handleEdit = record => {
    setEditingRecord(record)
    setModalType("edit")
    form.setFieldsValue(record)
  }
  const handleViewDetail = async record => {
    setSelectedId(record.ID)
    setModalType("view")
  }
  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  const [shownError, setShownError] = useState(false)
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const hasPermission = permissions.includes("package.new.list")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#005F90",
            margin: 0,
          }}
        >
          YÊU CẦU CHỈNH SỬA GÓI CƯỚC NHÀ MẠNG
        </h3>
      </div>
      <TabsBar tabChange={tabChange} setTabChange={setTabChange} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
        }}
      >
        {/* <FilterIn setFilter={setFilter} /> */}
        <div style={{ marginLeft: "auto" }}>
          <Space>
            <InputSearchStyle>
              <Input
                allowClear
                className="custom-input"
                maxLength={50}
                placeholder="Tên gói cước"
                // value={searchValue}
                // onChange={e => setSearchValue(e.target.value)}
                onPressEnter={e => setSearchValue(e.target.value)}
                onClear={e => setSearchValue("")}
              />
              <div className="custom-icon-search">
                <SvgIcon
                  name="searchStatistic"
                  // onClick={() => handleSearch("")}
                />
              </div>
            </InputSearchStyle>
          </Space>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>
      {permissions.includes("package.net.list") ? (
        <TableCustom
          isPrimary
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          onChange={handleTableChange}
          scroll={{ x: "max-content" }}
          bordered
        />
      ) : (
        <React.Fragment />
      )}

      {isModalImport && (
        <CustomModal
          title={"Tải file lên"}
          footer={null}
          size={"small"}
          open={isModalImport}
          onCancel={() => setIsModalImport(false)}
        >
          <ImportModal
            setIsModalImport={setIsModalImport}
            apiDownloadTemplate={NetworkManager.getNetworkExcelTemplate}
            apiUploadTemplate={NetworkManager.postNetworkExcelTemplate}
            onCancel={() => setIsModalImport(false)}
            setRefresh={setRefresh}
          />
        </CustomModal>
      )}

      {modalType === "edit" && (
        <ModalEditContract
          open={true}
          onCancel={() => setModalType(null)}
          record={editingRecord}
          onSuccess={() => {
            fetchNetworkData(searchValue)
            setModalType(null)
          }}
        />
      )}
      {/* {modalType === "view" && (
        <ViewDetailModal
          open={true}
          onCancel={() => setModalType(null)}
          form={form}
          recordId={selectedId}
        />
      )} */}
      {openRejectModal && (
        <RejectModal
          open={openRejectModal}
          onCancel={() => setOpenRejectModal(false)}
          onConfirm={handleRefuse}
          setRejectReason={setRejectReason}
        />
      )}
    </div>
  )
}

export default NetWorkPackageRequest
